// extracted by mini-css-extract-plugin
module.exports = {"Welcome":"Welcome_Welcome__3K0br","Welcome__heading":"Welcome_Welcome__heading__3vHi8","Welcome__para":"Welcome_Welcome__para__2navU"};